import wrapPromise from './wrap-promise';

const fetchData = (api: any) => {
  return wrapPromise(api);
};

export default fetchData;
